import Currency from '@modules/Currency.js'

export default {
    methods: {
        currency(number) {
            return Currency
                .format(number)
        }
    },
}
